import * as React from 'react';
import { Card } from '@blueprintjs/core';
import Landman from 'src/models/Landman';
import PropertyUtil from '../../../util/PropertyUtil';
import Button from '../../controls/forms/redesign/FormButton';
import MathUtil from 'src/util/MathUtil';

interface ILandmanRateCardProps {
    landman: Landman;
    navigate: (path: string) => void;
}

class LandmanRateCard extends React.Component<ILandmanRateCardProps> {
    onManageRatesClick = () => {
        this.props.navigate(`/landmen/${this.props.landman.id}/manage-rates`);
    };

    public render() {
        return (
            <Card className="lh-half-width" elevation={1}>
                <h6>Billing / Payment Information</h6>
                <div>
                    <u>
                        Current Rates (eff. date:{' '}
                        {PropertyUtil.SafeGet(() => this.props.landman.effectiveRate.effectiveDate.toString().slice(0, 10), 'NA')})
                    </u>
                </div>
                <div>Bill: {PropertyUtil.SafeGet(() => MathUtil.cleanNumber(this.props.landman.effectiveRate.billRate, 5), 'NA', '${0} / day')}</div>
                <div>Pay: {PropertyUtil.SafeGet(() => MathUtil.cleanNumber(this.props.landman.effectiveRate.payRate, 5), 'NA', '${0} / day')}</div>
                <div style={{ marginTop: '.5em', textAlign: 'right' }}>
                    <Button intent="primary" size="medium" text="Manage Rates" onClick={this.onManageRatesClick} />
                </div>
            </Card>
        );
    }
}

export default LandmanRateCard;



// WEBPACK FOOTER //
// ./src/components/personnel/components/LandmanRateCard.tsx